var services = [
  {
    id: 1,
    title: 'Accounting',
    content:
      'ABNCA provides accounting services to companies, NGOs, partnerships and other business entities. We offer a wide range of services that are individually tailored to meet our clients’ needs.  The services provided by us include:',
    functions: [
      {
        title: 'Bookkeeping',
        description: '',
      },
      {
        title: 'Financial Accounting',
        description: '',
      },
      {
        title: 'Payroll Accounting',
        description: '',
      },
      {
        title: 'Compliance with various Labour Laws',
        description: '',
      },
      {
        title: 'Compliance with Fiscal Laws (GST & Income Tax)',
        description: '',
      },
      {
        title: 'Compilation of Financial Statements',
        description: '',
      },
    ],
    example1: 'Bookkeeping',
    example2: 'Tax Management',
  },
  {
    id: 2,
    title: 'Audit & Assurance',
    content:
      "Audit is a procedure of closely monitoring the accounting information provided in a company's financial statements. Assurance, on the other hand, involves assessing and analysing different operations, processes, and procedures.  A good auditor can do more than just check the facts and figures in the reports. Validating the accuracy of the information you use to make your most critical financial decisions empowers you to be more confident in the direction you take your company in the future. We conduct your financial audit and ensure a professional delivery. We tailor our service to each client and their specific needs and requirements.",
    functions: [
      {
        title: 'Tax Audits under Income Tax Act',
        description:
          'As per the Income Tax Act, 1961, the tax audit is applicable in the below cases: 1) If the sales, turnover or gross receipts of a business exceed ₹10 crore (₹100 million) in a financial year; 2)	If the sales, turnover or gross receipts of a business exceed ₹1 crore (₹10 million) AND [the cash receipts are exceeding 5% of total turnover OR cash payments exceed 5% of total expenses]; 3) In case of professionals, tax audit is required if the services income or gross receipts exceed ₹50 lakh (₹5 million) in FY2020-21.',
      },
      {
        title: 'Statutory Audit under Companies Act',
        description:
          'Statutory Auditing is done to determine whether an organization provides a fair and accurate representation of its financial position by examining information such as bank balances, bookkeeping records, and financial transaction.  We provide the following statutory auditing services- Financial auditing as prescribed under Section 139 of the Companies Act, 2013, Cost auditing as prescribed under Section 148 of the Companies Act, 2013, Secretarial auditing as prescribed under Section 208 of the Companies Act, 2013 and Tax Auditing as prescribed under Section 44AB of the Income Tax Act, 1961.',
      },
      {
        title: 'Internal Audits',
        description:
          'Internal auditing is performed to guarantee that your firm is agreeing with the government standards and guidelines and is additionally utilized for identifying, understanding and mitigating financial risks.  The reports can be additionally used further to improve the performance of your firm.  ABNCA provides internal auditing services to firms, non-profit organizations, and private or public ltd organizations.',
      },
      {
        title: 'Stock Audit',
        description:
          'Stock audit is physical verification of your stock of material inventory and matching it with your on-book inventory.  It is an important tool for strengthening the internal control system.  We are well-equipped for carrying out stock audit not only for single-offices or factories but also those spread over multiple cities, or states in India.  We also provide advisory for automating and digitizing stock audit processes for large firms which can reduce manpower and unrequired inventory, enhance traceability, reduce pilferages and space needed to store the inventory, thus freeing up the firm’s capital for productive activities.',
      },
    ],
    example1: 'Inventory Audit',
    example2: 'Tax Audit',
  },
  {
    id: 3,
    title: 'Due Diligence & Compliance',
    content:
      'The process of compliance usually has a short-term or a regulatory checkbox focus.  ABNCA helps with all kinds of compliances including anti-corruption laws, environmental laws, data protection laws, safety regulations, corporate social responsibility laws or tax laws.  Due diligence involves thorough investigations and generation of (often) multiple measures for the same activity or underlying in order to develop deeper insights to guide critical business decision making such as acquisition, capital raising, entry into new markets, preparing defenses against changing market conditions or entry of more nimble players.  We have expertise across compliance functions – investigation, forensic analysis, reporting, process improvement and strategic decision making.  Due diligence refers to the process of research and analysis that is done before an acquisition, investment, business partnership or bank loan in order to determine the value of the subject of the due diligence or whether there are any major issues or potential issues.  ABNCA also helps in identification of undisclosed risks, highlighting key deal issues, and providing valuable insight on transaction synergies. It also tailors the approach for each individual transaction to maximise value and deliver a quality work product in a timely manner.',
    functions: [],
    example1: 'Financial Health Assessment',
    example2: 'Risk Assessment',
  },

  {
    id: 4,
    title: 'ESOP Policy',
    content:
      'ESOP policy covers performance incentives offered to employees in the form of stock options to enhance employee income and better align individual incentives with corporate goals.  ABNCA offers end-to-end solutions ranging from drafting the high-level policy details, designing payoff structures aligned with corporate goals, conducting probabilistic scenario analysis for option valuations, drafting the policy and auditing.',
    functions: [],
    example1: 'Policy Drafting',
    example2: 'Stock Option Structuring',
  },
  {
    id: 5,
    title: 'GST',
    content:
      'The goods and services tax (GST) is a tax on goods and services sold domestically for consumption. The tax is included in the final price and paid by consumers at point of sale and passed to the government by the seller. ABNCA provides expert consultation and keeps its clients up-to date on the compliances and amendments of the GST laws.  ABNCA caters to the needs of each customer by providing the below GST services:',
    functions: [
      {
        title: 'Obtaining Registration',
        description: '',
      },
      {
        title: 'Prepare and File Returns',
        description: '',
      },
      {
        title: 'Advise on GST Matters',
        description: '',
      },
      {
        title: 'Obtaining LUT',
        description: '',
      },
      {
        title: 'GST Audits',
        description: '',
      },
      {
        title: 'Updation on Changes in Law',
        description: '',
      },
      {
        title: 'Filing for GST Refund',
        description: '',
      },
      {
        title: 'Representation before Tax Authorities',
        description: '',
      },
    ],
    example1: 'Registration',
    example2: 'Returns filing',
  },
  {
    id: 6,
    title: 'Income Tax',
    content:
      'Our team at ABNCA have years of expertise over income tax laws and we provide various income tax services as below.  We help file income tax returns in a timely manner and with an accurate representation of your income to help you avoid penalties due to potential non-compliance. We cover all income sources, including income from salary, rental income, capital gains, dividends, interest on deposits, royalty, lottery, profits/gains from business or profession and more. We offer full suite of expertise required for a multi-year minimization of both direct and indirect taxes.  We also cater to the needs of the clients to plan their taxes. With the help of tax planning, one can ensure that all elements of a financial plan can function together with maximum tax-efficiency.',
    functions: [
      {
        title: 'IT Planning & Return Filing',
        description:
          'Tax planning is the analysis of the financial situation and future plans of a firm to and using it to develop a financial plan that maximizes tax efficiency of the firm by making the best use of the various tax exemptions and text credits under IT Act, 1961 , deductions (under Sections 80C through to 80U) and benefits.  We offer full suite of expertise required for a multi-year minimization of both direct and indirect taxes.  We help file income tax returns in a timely fashion and with an accurate representation of your income to help you avoid penalties due to potential non-compliance.  We cover all income sources, including income from salary, rental income, capital gains, dividends, interest on deposits, royalty, lottery, profits/gains from business or profession and more.',
      },
      {
        title:
          'Obtaining Lower Tax Certificate both for Resident and Non Resident assessees.',
        description:
          'Under the Indian Income tax Act, 1961 any income or capital gain receivable by the NRI from any Resident or NRI, is liable for withholding taxes/tax deduction at source (TDS) by the Payer at the prescribed rate of tax ranging from 10% to 30%.  However, in most cases of NRIs, the actual tax liability is lower or Nil.  This and other such cases can be suitably addressed by obtaining lower/tax exempt certificate.  Talk to us if you think your circumstances may enable you to qualify for the certificate and we could explore your options and take applicable possibilities to execution.',
      },
      {
        title: 'Obtaining Tax Residency Certificate (TRC)',
        description:
          'Tax Residency Certificate is required by Indian residents who earn income from countries with whom India has a double taxation avoidance treaty.  We help you make an application to the assessing officer in Form No. 10FA and address questions, if any, to get you your expedited tax residency status certificate.',
      },
      {
        title: 'E-TDS return filing',
        description:
          'Individuals and HUF are exempt from TDS as they are not required to audit their books.  However for payments towards rent where the rent exceeds ₹50K/month TDS must be deducted at 5% under all circumstances.  We help you with electronic filing of TDS or, claim TDS return in case your income was lower than the taxable threshold.',
      },
      {
        title: 'Scrutiny assessment',
        description:
          'Scrutiny assessment is similar to a formal notice of tax audit by a government agency.  It refers to the examination of an income tax return wherein the assessee is given the opportunity to substantiate the income declared and reductions claimed in the tax submission.  We help you prepare for tax scrutiny, collate evidence and provide advisory services.',
      },
      {
        title: 'Drafting appeals and appearing before the CIT',
        description:
          'ABNCA is well-experienced in drafting appeals, marshalling evidence and presenting it for consideration to suitable authorities in case a tax charge is disputed.  We provide this service across firm sizes, including, to wealthy individuals.',
      },
      {
        title: 'Conducting Tax Audit and submission of Audit Report',
        description:
          'Income tax authorities or investors may request the conduct of a tax audit of your books.  The purpose of a tax audit is to assess if the reported tax amount is correct.  Being selected for an audit by a government agency does not mean that your books are incorrect.  In some cases you may actually even be due for a refund.  Whatever the case, ABNCA can assist you throughout the audit, including filing the report or providing expert advice in case you wish to challenge the findings of the tax audit.',
      },
      {
        title: 'Conducting Transfer Pricing Study and submission of TP Report',
        description:
          'In case you run an organization that has effort, earnings and risks booked in multiple tax jurisdictions then then transfer applies to you.  You must allocate the appropriate portion of the income to the correct entity and pay tax accordingly.  A transfer pricing study analyses the market value of transferred goods and establishes inter-company pricing according to transfer pricing rules of the countries involved. This study serves not only as a foundation for determining the transfer prices. It also demonstrates proper intent to the tax authorities.  Finally, developing a transfer pricing study is not only a defensive move to protect in case of a tax audit. It also serves as a key tax planning tool in structuring your international business.  If you have transactions between related businesses, consider talking to ABNCA.',
      },
      {
        title: 'Issue of Certification for repatriation of funds from India',
        description:
          'Remittance of funds held in India by non-residents to outside India is termed as “Repatriation” and requires necessary clearance from authorities.  It typically applies to NRIs/PIOs.  ABNCA helps in obtaining the certificate and completing other actuarial formalities required by authorities prior to the issuance of the certificate.',
      },
      {
        title: 'Tax Consultancy for Residents & NRIs',
        description:
          'ABNCA provides advisory and compliance services encompassing the entire gamut of Taxation (Customs, DTAA, Income Tax, Wealth Tax, etc), Foreign Exchange Law (Companies Act, FCRA, RBI/FEMA, etc).',
      },
    ],
    example1: 'IT Planning & Returns Filing',
    example2: 'NRI Consultancy',
  },
  {
    id: 7,
    title: 'Labor Compliance',
    content: '',
    functions: [],
    example1: 'Compliance of Wage Register',
    example2: 'Registration with Labor Bureau',
  },
  {
    id: 8,
    title: 'M&A Analysis',
    content:
      'A merger is the combination of two or more entities into a single entity.  ABNCA is a recognized consultant for providing end-to-end M&A support including drafting the letter of intent, recruiting third part consultant, valuation, negotiating employee contracts, preparing exclusivity clauses, financial and taxation due diligence and post-merger works.  ABNCA helps in different phases of acquiring a company or selling a business division.  We focus on industry specific needs and cater to various tax and regulatory aspects of each transaction to bring home the competitive advantage to the Companies.',
    functions: [],
    example1: 'Paperwork',
    example2: 'Valuation analysis',
  },

  {
    id: 9,
    title: 'New Company Set Up',
    content:
      'We assist in setting up sole props, partnerships and private ltd under the Companies Act, 2013 or the Shops & Establishment Act .  We also help in establishing NGOs under the Societies Registration Act or the Indian Trusts act or the Companies Act, 2013.  We also help with the company name finalization and registration.',
    functions: [],
    example1: 'Licenses',
    example2: 'Funding Advisory',
  },
  {
    id: 10,
    title: 'Payroll',
    content:
      'Payroll includes planning, disbursement and maintenance of records of employee’s salary/wages/bonus and withheld taxes.  Payroll needs to comply with the Payment of Wages Act, 1936 which regulates payment of wages to direct and indirect employees.  The act warrants payments of wages on time and without any deductions except those authorized under the Act.  ABNCA brings to you the end-end payroll services.  Check out the subsections below for details:',
    functions: [
      {
        title: 'Salary calculation',
        description:
          'ABNCA brings to you the end-end payroll services which includes net salary calculation of each of your employees, freelancers, interns, contractors which includes i) gross salary - such as basic, HRA, arrears, bonus and other allowances, and ii) deductions - such as professional tax, income tax, provident fund, leave adjustments and loan repayments.',
      },
      {
        title: 'Employee Tax calculation (TDS)',
        description:
          'TDS is Tax Deducted at Source.  It is the amount deducted by a payee on the salary of the     employee periodically depending upon the tax slab his/her income falls under.  ABNCA helps you calculate TDS amount of each of employees with our advanced TDS calculator that is compliant with the Section 192 of the Income Tax Act based on Payee type, Availability of a valid PAN, IT filing status over last 3 years, Source of income and amount liable for TDS.',
      },
      {
        title: 'PT,PF and ESI Calculation',
        description:
          'PT is Professional Tax, an income tax levied by the government on employees, businessman, freelancer.  The employer is obligated to deduct it at source and the threshold and slabs vary from state to state.  ABNCA assists in periodic calculation of professional tax and end-of-year reconciliation in compliance with the guidelines of the Income Tax Act, 1961.  PF, Provident Fund, is a deduction on the gross salary and a proportional or a matching obligation on the employer.  We assist with PF calculations and make recommendations on a tax efficient investment of the PF pool.  ESI is Employee State Insurance.  ABNCA assists in ESI deductions and contributions to be made towards eligible employee on a periodic basis complying with the ESI Act, 1948.',
      },
      {
        title: 'Pay slips & reports',
        description:
          'ABNCA helps prepare payslips for employees, freelancers, interns and contractors based on their individual incomes and deductions.  We also provide services such as making error free reports and documentation for taxation and other purposes.',
      },
      {
        title: 'Leave & Expense management',
        description:
          'ABNCA helps with employee leave management services like automating and record-keeping of attendance, calculation of leave compensation and reimbursement.',
      },
      {
        title: 'Complete employee data',
        description:
          'ABNCA assists in maintaining and analysing entire employee database which can be used for assessing employee performance, employee retention, advice you on payroll savings, we provide complete data protection and privacy with compliance with the Information Technology Act , 2000.',
      },
    ],
    example1: 'Employee Cost Accounting',
    example2: 'Employee Data Management',
  },
  {
    id: 11,
    title: 'Registration',
    content:
      'ABNCA assists in all type of registrations for individuals, sole proprietorship, partnership firms, public or private ltd companies, non-profit organisations or any other businesses like shops, restaurants, clubs, amusement parks.  Feel free to reach out to us if you need guidance on which forms to fill or time estimates for completion of formalities.  Check below details of our registration services:',
    functions: [
      {
        title: 'Shops and Establishment',
        description:
          'In India every state has its own rules and regulations for obtaining the shops and establishment registration certificate, which is mandatory to be obtained within 30 days of the commencement of the work for commercial establishments such as shops, restaurants, clubs or amusement parks.  We assist in obtaining the certificates consistent with rules and regulations of your state/city.',
      },
      {
        title: 'Professional Tax (PT)',
        description:
          'Professional tax is an income tax levied by the state government on salaried professionals, business professional, freelancers.  The threshold and percentages vary by the state.  ABNCA assists in obtaining the PT registration number, file returns and manage the periodic paperwork needed for compliance, audit or for use in preparation of salary slips.',
      },
      {
        title: 'Trade License',
        description:
          'Trade License is legal document issued by the local authority such as municipal corporations to individuals who wish to setup businesses in a particular area.  We assist by advising on the procedure, form filling and liaising with the regulatory authorities.  The following documents are necessary to obtain the license: a. Khata certificate, b. NOC from neighbors, c. property tax documents, d. occupancy documents and e. the applicants’ PAN card.',
      },
      {
        title: 'Employee Provident Fund (EPF)',
        description:
          'As per the Employees Provident Funds and Miscellaneous Provisions Act, 1952, it is mandatory to get the EPFO (employee provident fund organization) registration done if your proprietorship, company, society, trust, has more than 20 workers.  The process is simple but involves a fair bit of paperwork due to several prerequisite certificates.  We do it all – obtaining GST certificate, shop and establishment certificate, digital signature, PAN and ADHAR of the directors/partners and more.  We also assist employers, employees, and pensioners in registering all PF related grievances. ',
      },
      {
        title: 'Employee State Insurance (ESI)',
        description:
          'Any establishment with more than 10 employees requires ESI registration as per the ESI Act 1948, any establishment.  ABNCA helps you obtain the ESI registration certificate. We also assist in filling the Form-1 and facilitating the generation of 17-digit ESI number.',
      },
      {
        title: 'Goods and Service Tax (GST)',
        description:
          'A GST number is mandatory for all businesses, irrespective of their type, if their sales turnover exceeds a threshold (₹20L or ₹40L depending on the state).  We help in procuring the GST number, closing it in case you wish to close down your firm and periodic GST filing.',
      },
      {
        title: 'Import Export Code (IEC)',
        description:
          'IEC is a 10-digit identification number mandatory for any establishment to enjoy import export benefits like broad outreach, lifetime validity, government subsidies, reduced set of compliances.  ABNCA assists in obtaining fresh IEC or extensions.  The documents required are: a. applicant PAN card; b. applicant passport-size photo; c. a cancelled check drawn on the primary bank account for your business and; d. business address proof.',
      },
      {
        title: 'STPI and Non STPI',
        description:
          'STPI refers to Software Technology Park of India, is a scheme established in 1991 by Government of India to improve the software exports of the country. We provide end-to-end advise on the business plan preparation, registration process, licensing requirement and liaising with the authorities.',
      },
      {
        title: 'MSME or Udyog Aadhar',
        description:
          'MSME and Udyog Adhar certificates are beneficial to get tax exemptions, easier credit, qualifying for a relaxed criteria under government tenders.  We can help you secure the certificates.',
      },
      {
        title: 'Trademark',
        description:
          'ABNCA assists in searching trademark names and making sure your choices are compliant with authority requirements.  We also take care of the end-to-end process around Form TM- 48, including smooth conduction of the examination and post examination process.',
      },
      {
        title: 'TAN/PAN',
        description:
          'TAN is mandatory under the section 203A of the income Tax Act for all persons who have earnings.  PAN number is mandatory if the earning exceeds minimum threshold (for an individual: ₹2.5L or ₹5.0L depending on the tax code in use, for businesses ₹5.0L and ₹0 for any charitable trust).  The government also requires all transactions about ₹50L to be individually recorded under the PAN.  We assist in filing form 49A for Indians and Form 49AA for a foreign entity and procuring the TAN/PAN as applicable.',
      },
    ],
    example1: 'International Trade',
    example2: 'Shops & Establishment',
  },
  {
    id: 12,
    title: 'Report & Document',
    content:
      'ABNCA prepares and maintains financial reports for regulatory compliance, debt management, trend identification and systematic tracking of assets and liabilities.  We translate data into industry-standard KPIs and graphic representations which make inter-departmental discussions more meaningful and communications with external stakeholders or regulators clear and compact.  Our team has extensive experience with advanced excel features.  We have worked with several large corporations to improve senior management communications across business functions by standardizing data and information communication and making custom-built templates for word, PowerPoint and excel.  Leave your reporting and documentation needs to us so you can focus on your core competencies.',
    functions: [],
    example1: 'Business Intelligence Tools',
    example2: 'Translate Data into KPIs & Graphs',
  },
];
export default services;
